import { Layout } from "antd";
import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import InterventionTemplatesTable from "@/components/ListTable/InterventionTemplatesTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { INTERVENTION_TEMPLATES_FILTERS } from "@/entities/intervention-templates";
import InterventionTemplateAddButton from "@/modules/intervention-template/intervention-template-add-button";
import { ListProvider } from "@/modules/list";

const { Content } = Layout;

const InterventionTemplates = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader
        title={t("global:interventionTemplatePlural")}
        extra={[
          <InterventionTemplateAddButton key="intervention-template-add-button" />,
        ]}
      />
      <Content>
        <ListProvider
          model="interventionTemplates"
          storageKey={STORAGE_KEYS.INTERVENTION_TEMPLATES}
          hiddenFilters={{ [INTERVENTION_TEMPLATES_FILTERS.LATEST]: true }}
        >
          <InterventionTemplatesTable />
        </ListProvider>
      </Content>
    </>
  );
};

export default InterventionTemplates;
